import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SharedRequestComponent } from './pages/project/shared-request/shared-request.component';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./pages/pages.module').then((m) => m.PagesModule),
  },
  {
    path: 'shared-request',
    component: SharedRequestComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
